import { flightAdapter, vertiportAdapter } from '@redux/intercom/intercom.adapters';
import { createSlice, EntityState, PayloadAction } from '@reduxjs/toolkit';

import { Flight, Vertiport } from '@/types/intercom/intercom.types';

export type IntercomState = {
  vertiports: EntityState<Vertiport, string>;
  flights: EntityState<Flight, string>;
};

export const INTERCOM_INITIAL_STATE: IntercomState = {
  vertiports: vertiportAdapter.getInitialState(),
  flights: flightAdapter.getInitialState(),
};

const intercom = createSlice({
  name: 'intercom',
  initialState: INTERCOM_INITIAL_STATE,
  reducers: {
    updateIntercom: (
      state,
      action: PayloadAction<{
        vertiports: Vertiport[];
        flights: Flight[];
      }>,
    ) => {
      const { vertiports, flights } = action.payload;
      vertiportAdapter.setAll(state.vertiports, vertiports);
      flightAdapter.setAll(state.flights, flights);
    },
    upsertVertiport: ({ vertiports }, action: PayloadAction<Vertiport>) => {
      vertiportAdapter.upsertOne(vertiports, action.payload);
    },
    deleteVertiport: ({ vertiports }, action: PayloadAction<Vertiport>) => {
      vertiportAdapter.removeOne(vertiports, action.payload.code);
    },
    upsertFlight: ({ flights }, action: PayloadAction<Flight>) => {
      flightAdapter.upsertOne(flights, action.payload);
    },
    deleteFlight: ({ flights }, action: PayloadAction<Flight>) => {
      flightAdapter.removeOne(flights, action.payload.id);
    },
  },
});

export const { updateIntercom, upsertVertiport, deleteVertiport, upsertFlight, deleteFlight } = intercom.actions;
export default intercom.reducer;
